import { MESSAGES } from 'constants/Constants';
import ApiService from 'services/ApiService';

import { addNotification } from 'store/notificationModule/actions';
import { extractError } from '../../utils/functions';

const ACTION_PREFIX = 'multiUser';
export const MultiUserActionTypes = {
  FETCH_AVAILABLE_SUBSCRIPTIONS_WAITING: `${ACTION_PREFIX}/FETCH_AVAILABLE_SUBSCRIPTIONS_WAITING`,
  FETCH_AVAILABLE_SUBSCRIPTIONS_FAILED: `${ACTION_PREFIX}/FETCH_AVAILABLE_SUBSCRIPTIONS_FAILED`,
  FETCH_AVAILABLE_SUBSCRIPTIONS_COMPLETED: `${ACTION_PREFIX}/FETCH_AVAILABLE_SUBSCRIPTIONS_COMPLETED`,
  UPDATE_PURCHASE_SUBSCRIPTION_TYPE: `${ACTION_PREFIX}/UPDATE_PURCHASE_SUBSCRIPTION_TYPE`,
  UPDATE_PURCHASE_SEATS: `${ACTION_PREFIX}/UPDATE_PURCHASE_SEATS`,
  USERS_LIST_VALIDATION_WAITING: `${ACTION_PREFIX}/USERS_LIST_VALIDATION_WAITING`,
  USERS_LIST_VALIDATION_FINISHED: `${ACTION_PREFIX}/USERS_LIST_VALIDATION_FINISHED`,
  UPLOAD_USERS_FILE_WAITING: `${ACTION_PREFIX}/UPLOAD_USERS_FILE_WAITING`,
  UPLOAD_USERS_FILE_FAILED: `${ACTION_PREFIX}/UPLOAD_USERS_FILE_FAILED`,
  UPLOAD_USERS_FILE_COMPLETED: `${ACTION_PREFIX}/UPLOAD_USERS_FILE_COMPLETED`,
  ASSIGN_MULTI_USERS_WAITING: `${ACTION_PREFIX}/ASSIGN_MULTI_USERS_WAITING`,
  ASSIGN_MULTI_USERS_FAILURE: `${ACTION_PREFIX}/ASSIGN_MULTI_USERS_FAILURE`,
  ASSIGN_MULTI_USERS_COMPLETED: `${ACTION_PREFIX}/ASSIGN_MULTI_USERS_COMPLETED`,
  NOTIFICATION_PROCESS: `${ACTION_PREFIX}/NOTIFICATION_PROCESS`,
};

export function fetchAvailableSubscriptionsInProgress() {
  return {
    type: MultiUserActionTypes.FETCH_AVAILABLE_SUBSCRIPTIONS_WAITING,
  };
}

export function fetchAvailableSubscriptionsFailed(msgError) {
  return {
    type: MultiUserActionTypes.FETCH_AVAILABLE_SUBSCRIPTIONS_FAILED,
    payload: {
      status: msgError || MESSAGES.UPLOAD_USERS_FILE_FAILED,
    },
  };
}

export function fetchAvailableSubscriptionsCompleted(subscriptions) {
  return {
    type: MultiUserActionTypes.FETCH_AVAILABLE_SUBSCRIPTIONS_COMPLETED,
    payload: {
      subscriptions,
    },
  };
}

export function updatePurchasedSubscription(type, period) {
  return {
    type: MultiUserActionTypes.UPDATE_PURCHASE_SUBSCRIPTION_TYPE,
    payload: {
      type,
      period,
    },
  };
}

export function updatePurchasedSeats(seats, months) {
  return {
    type: MultiUserActionTypes.UPDATE_PURCHASE_SEATS,
    payload: {
      seats,
      months,
    },
  };
}

export function validationInProgress() {
  return {
    type: MultiUserActionTypes.USERS_LIST_VALIDATION_WAITING,
    payload: {
      status: MESSAGES.USERS_LIST_VALIDATION_WAITING,
    },
  };
}

export function validationCompleted(msgError) {
  return {
    type: MultiUserActionTypes.USERS_LIST_VALIDATION_FINISHED,
    payload: {
      status: msgError || null,
    },
  };
}

export function uploadUsersFileInProgress() {
  return {
    type: MultiUserActionTypes.UPLOAD_USERS_FILE_WAITING,
  };
}

export function uploadUsersFileFailed(msgError) {
  return {
    type: MultiUserActionTypes.UPLOAD_USERS_FILE_FAILED,
    payload: {
      status: msgError || MESSAGES.UPLOAD_USERS_FILE_FAILED,
    },
  };
}

export function uploadUsersFileCompleted(file) {
  return {
    type: MultiUserActionTypes.UPLOAD_USERS_FILE_COMPLETED,
    payload: {
      file,
    },
  };
}

export function assignMultiUsersInProgress() {
  return {
    type: MultiUserActionTypes.ASSIGN_MULTI_USERS_WAITING,
    payload: {
      status: MESSAGES.ASSIGN_MULTI_USERS_WAITING,
    },
  };
}

export function assignMultiUsersFailed(msgError) {
  return {
    type: MultiUserActionTypes.ASSIGN_MULTI_USERS_FAILURE,
    payload: {
      status: MESSAGES.ASSIGN_MULTI_USERS_FAILED,
    },
  };
}

export function assignMultiUsersCompleted(errors, users) {
  return {
    type: MultiUserActionTypes.ASSIGN_MULTI_USERS_COMPLETED,
    payload: {
      errors,
      users,
    },
  };
}

export function addProcessNotification(notification) {
  return {
    type: MultiUserActionTypes.NOTIFICATION_PROCESS,
    payload: {
      notification,
    },
  };
}

export const MultiUserActions = {
  fetchAvailableSubscriptionsInProgress,
  fetchAvailableSubscriptionsFailed,
  fetchAvailableSubscriptionsCompleted,
  updatePurchasedSubscription,
  updatePurchasedSeats,
  validationInProgress,
  validationCompleted,
  uploadUsersFileInProgress,
  uploadUsersFileFailed,
  uploadUsersFileCompleted,
  assignMultiUsersInProgress,
  assignMultiUsersFailed,
  assignMultiUsersCompleted,
  addProcessNotification,
  assignMultipleUsers,
  uploadUsersFile,
  fetchAvailableSubscriptions,
};

/**
|--------------------------------------------------
| Async Actions
|--------------------------------------------------
*/
export function assignMultipleUsers(users, autoPassword, type, period, cb = null) {
  return dispatch => {
    dispatch(assignMultiUsersInProgress());
    ApiService.assignMultiUsers({ users, auto_password: autoPassword, type, period }).then(
      res => {
        let isRequestWaiting = false;
        const interval = setInterval(() => {
          if (isRequestWaiting) {
            return;
          }

          if (!isRequestWaiting) {
            isRequestWaiting = true;
          }

          ApiService.assignMultiUsersProgress().then(
            res2 => {
              //eslint-disable-line
              if (res2.data.status === 'FINISHED') {
                dispatch(addNotification(MESSAGES.ASSIGN_MULTI_USERS_COMPLETED, 'success'));
                dispatch(assignMultiUsersCompleted(res2.data, users));

                if (cb) {
                  cb(res2.data);
                }

                window.localStorage.removeItem('last_upload_file');
                clearInterval(interval);
              }
              isRequestWaiting = false;
            },
            err => {
              const error = err.response;
              if (error.status === 400) {
                dispatch(assignMultiUsersFailed(error.data));
                clearInterval(interval);
              }
              isRequestWaiting = false;
            },
          );
        }, 2000);
      },
      err => {
        const error = err.response;
        dispatch(assignMultiUsersFailed(error.data));
      },
    );
  };
}

export function uploadUsersFile(f) {
  return dispatch => {
    dispatch(uploadUsersFileInProgress());
    ApiService.uploadUsersFile({ file: f }).then(
      res => {
        dispatch(uploadUsersFileCompleted(res.data));
      },
      err => {
        const error = err.response;
        let errorMsg = extractError(error.data);
        if (error.data && error.data.file) {
          errorMsg = error.data.file[0]; //eslint-disable-line
        }

        dispatch(addNotification(errorMsg, 'error'));
        dispatch(uploadUsersFileFailed(errorMsg));
      },
    );
  };
}

export function fetchAvailableSubscriptions() {
  return dispatch => {
    dispatch(fetchAvailableSubscriptionsInProgress());
    ApiService.fetchAvailableSubscriptions().then(
      res => {
        dispatch(fetchAvailableSubscriptionsCompleted(res.data));
      },
      err => {
        const error = err.response;
        const errorMsg = extractError(error.data);
        dispatch(addNotification(errorMsg, 'error'));
        dispatch(fetchAvailableSubscriptionsFailed(errorMsg));
      },
    );
  };
}
